import {
  getPreviewProjectRoute,
  type GetPreviewProjectParams,
  type GetPreviewProjectResponse,
} from '@enki/contracts/preview/get-project';
import {
  getPreviewProjectsRoute,
  type GetPreviewProjectsResponse,
} from '@enki/contracts/preview/get-projects';
import {
  ActivityPayload,
  AppliedProjectStat,
  toLegacyPreviewQuestion,
} from '../hydra';
import { requestContract } from './contract-client';

export async function getPreviewProject(
  token: string,
  { projectSlug }: GetPreviewProjectParams
): Promise<ActivityPayload> {
  const project = await requestContract(getPreviewProjectRoute, {
    token,
    params: { projectSlug },
  });
  return previewProjectToActivity(project);
}

export async function getPreviewProjectsDashboard(
  token: string
): Promise<Array<AppliedProjectStat>> {
  const projects = await requestContract(getPreviewProjectsRoute, {
    token,
  });
  return projects.map(previewProjectSummaryToLegacyStat);
}

function previewProjectToActivity(
  project: GetPreviewProjectResponse
): ActivityPayload {
  return {
    id: project.activity_id,
    updated_at: project.exercise.updated_at,
    created_at: project.exercise.created_at,
    is_core: null,
    title: project.title,
    summary: project.summary,
    external_url: null,
    type: 'EXERCISE',
    mission_id: null,
    estimate_seconds: 0,
    index_in_mission: 0,
    exercise_id: project.exercise.id,
    is_teams_only: false,
    slug: project.slug,
    activity_session_id: -1,
    activity_session_instructor_review: null,
    activity_session_instructor_score: null,
    activity_session_instructor_question_comments: [],
    latest_submission: project.latest_submission,
    exercise: {
      id: project.exercise.id,
      updated_at: project.exercise.updated_at,
      created_at: project.exercise.created_at,
      description: project.exercise.description,
      lesson: project.exercise.lesson,
      difficulty: 0,
      activity_id: project.activity_id,
      slug: project.exercise.slug,
      questions: project.exercise.questions.map(toLegacyPreviewQuestion),
    },
    content_id: project.activity_id,
    content_slug: project.content_slug,
    content_title: project.content_title,
    next_activity_slug: null,
    next_mission_slug: null,
  };
}

function previewProjectSummaryToLegacyStat(
  project: GetPreviewProjectsResponse[number]
): AppliedProjectStat {
  return {
    ...project,
    image_url: project.image_url ?? '',
    completedQuestions: null,
    isLocked: false,
  };
}
